import { useEffect, useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Slider from './components/Slider';
import WhyChooseUs from './components/WhyChooseUs';
import Welcome from './components/Welcome';
import Mentor from './components/Mentor';
import Footer from './components/Footer';
import ContactUs from './components/ContactUs';
import Backend from './components/Backend';
import SuccessStories from './components/SuccessStories';

function App() {
  const [route, setRoute] = useState(() => window.location.hash || '#home');

  useEffect(() => {
    const handleHashChange = () => {
      setRoute(window.location.hash || '#home');
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const renderPage = () => {
    switch (route) {
      case '#about':
        return (
          <main className="page-section">
            <div className="content">
              <h1>About ANKURIVF</h1>
              <p>Compassionate fertility care with advanced medical support.</p>
            </div>
            <Welcome />
          </main>
        );
      case '#treatments':
        return (
          <main className="page-section">
            <div className="content">
              <h1>Treatments</h1>
              <p>Explore IVF, IUI, and other fertility solutions.</p>
            </div>
            <Mentor />
          </main>
        );
      case '#stories':
        return (
          <main className="page-section">
            <div className="content">
              <h1>Success Stories</h1>
              <p>Real journeys and inspiring milestones.</p>
            </div>
            <SuccessStories />
          </main>
        );
      case '#ai':
        return (
          <main className="page-section">
            <Backend />
          </main>
        );
      case '#contact':
        return (
          <main className="page-section">
            <ContactUs />
          </main>
        );
      default:
        return (
          <>
            <Slider />
            <WhyChooseUs />
            <SuccessStories />
            <Welcome />
            <Mentor />
            <ContactUs />
          </>
        );
    }
  };

  return (
    <div className="App">
      <Navbar />
      {renderPage()}
      <Footer />
    </div>
  );
}

export default App;
